<template>
  <div class='i'>
    <img :src="imagens['subImg' + sub ]" alt=""/>
  </div>
</template>

<script>
//o id usado na nomeacao das imagem é o id_sub_mapa
import sub0 from '@/assets/subs/sub0.jpg'
import sub1 from '@/assets/subs/sub1.jpg'
import sub2 from '@/assets/subs/sub2.jpg'
import sub3 from '@/assets/subs/sub3.jpg'
import sub4 from '@/assets/subs/sub4.jpg'
import sub5 from '@/assets/subs/sub5.jpg'
import sub6 from '@/assets/subs/sub6.jpg'
import sub7 from '@/assets/subs/sub7.jpg'
import sub8 from '@/assets/subs/sub8.jpg'
import sub9 from '@/assets/subs/sub9.jpg'
import sub10 from '@/assets/subs/sub10.jpg'
import sub11 from '@/assets/subs/sub11.jpg'
import sub12 from '@/assets/subs/sub12.jpg'
import sub13 from '@/assets/subs/sub13.jpg'
import sub14 from '@/assets/subs/sub14.jpg'
import sub15 from '@/assets/subs/sub15.jpg'
import sub16 from '@/assets/subs/sub16.jpg'
import sub17 from '@/assets/subs/sub17.jpg'
import sub18 from '@/assets/subs/sub18.jpg'
import sub19 from '@/assets/subs/sub19.jpg'
import sub20 from '@/assets/subs/sub20.jpg'
import sub21 from '@/assets/subs/sub21.jpg'
import sub22 from '@/assets/subs/sub22.jpg'
import sub23 from '@/assets/subs/sub23.jpg'
import sub24 from '@/assets/subs/sub24.jpg'
import sub25 from '@/assets/subs/sub25.jpg'
import sub26 from '@/assets/subs/sub26.jpg'
import sub27 from '@/assets/subs/sub27.jpg'
import sub28 from '@/assets/subs/sub28.jpg'
import sub29 from '@/assets/subs/sub29.jpg'
import sub30 from '@/assets/subs/sub30.jpg'
import sub31 from '@/assets/subs/sub31.jpg'
import sub32 from '@/assets/subs/sub32.jpg'



export default {
  name: 'sub-imagens',
  mixins: [],
  props: {
    sub : { type: Number, default: 0 },
  },
  created () {
    
  },
  data () {
    return {
      idSub: 0,
      imagens: {
        subImg0: sub0,
        subImg1: sub1,
        subImg2: sub2,
        subImg3: sub3,
        subImg4: sub4,
        subImg5: sub5,
        subImg6: sub6,
        subImg7: sub7,
        subImg8: sub8,
        subImg9: sub9,
        subImg10: sub10,
        subImg11: sub11,
        subImg12: sub12,
        subImg13: sub13,
        subImg14: sub14,
        subImg15: sub15,
        subImg16: sub16,
        subImg17: sub17,
        subImg18: sub18,
        subImg19: sub19,
        subImg20: sub20,
        subImg21: sub21,
        subImg22: sub22,
        subImg23: sub23,
        subImg24: sub24,
        subImg25: sub25,
        subImg26: sub26,
        subImg27: sub27,
        subImg28: sub28,
        subImg29: sub29,
        subImg30: sub30,
        subImg31: sub31,
        subImg32: sub32,
      },
    }
  },
  mounted () {},
  methods: {
    setId(id){
      this.idSub = id || 0
    }
  },

}
</script>

<style lang="scss" scoped>
.i{
  width: 100%;
  height: 10rem;
  overflow: hidden;
  position: relative;
}
 img{
  width:100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  
}


</style>
